import React from 'react';
import InsuranceQuoteSelect from '../../InsuranceQuoteSelect';

// Homepage hero (STATIC, code-managed). The background image is served from the
// stable /public path (NOT a webpack import) so it can be preloaded from index.html
// and downloaded in parallel with the JS bundle — the path here MUST match the
// <link rel="preload"> in public/index.html. "GM Insurance Services" carries a TM
// mark (California state trademark) on this prominent use.
const homeHero = `${process.env.PUBLIC_URL}/home-hero.jpg`;
const HomeF1 = React.memo(() => {
    return (
        <div className="landing landingImg" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${homeHero})`, paddingBottom: "3.5em" }}>
            <div className="main-headings-sec">
                <h1 className="landing-heading">
                    Compare <span className="color-head">Insurance Quotes</span><br />
                    with <span className="color-head">GM</span> Insurance Services<sup style={{ fontSize: "0.4em", verticalAlign: "super" }}>™</sup>
                </h1>
            </div>
            <div className="container landing-form">
                <InsuranceQuoteSelect placeholder="Select Insurance" buttonText="Get a Free Quote" />
            </div>
            <div className="container">
                <p className="landing-para" style={{ fontSize: "16px", lineHeight: "24px" }}>
                    Affordable auto, commercial auto, trucking, business, homeowners, workers compensation,
                    and earthquake insurance options for California customers.
                </p>
                <p className="landing-para" style={{ fontSize: "16px", lineHeight: "24px", paddingTop: "12px" }}>
                    GM Insurance Services helps drivers, homeowners, and business owners compare insurance quotes
                    and find coverage that fits their needs and budget. Whether you need personal insurance or
                    business insurance, our team can help you review available options and request a quote.
                </p>
            </div>
        </div>
    );
});

export default HomeF1;
